export default {
    CAReceipt: 20,
    BUTreasuryWithdrawal: 31
};
  